import { useMemo } from 'react'
import { SHORT_JSON_LINES } from '../config'
import { countLines, formatJson } from '../lib'
import { Disclosure } from './disclosure'

export function JsonBlock({
  value,
  label = 'JSON',
  defaultOpen,
}: {
  value: unknown
  label?: string
  defaultOpen?: boolean
}) {
  const json = useMemo(() => formatJson(value), [value])
  const lines = countLines(json)

  return (
    <Disclosure
      label={`${label} (${lines.toLocaleString('en-US')} lines)`}
      defaultOpen={defaultOpen ?? lines <= SHORT_JSON_LINES}
    >
      <pre className="bg-surface-low m-0 max-h-[480px] overflow-auto rounded-sm p-3 font-mono text-[12px] leading-5">
        {json}
      </pre>
    </Disclosure>
  )
}
